import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer'
import Navbar, { Header, Brand } from 'react-bootstrap/lib/Navbar'
import NavDropdown from 'react-bootstrap/lib/NavDropdown'
import Nav from 'react-bootstrap/lib/Nav'
import NavItem from 'react-bootstrap/lib/NavItem'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import Logo from 'react-icons/lib/ti/flash-outline'

import ChangeSemester from 'components/ChangeSemester'

const TopNav = ({ name, session, currentPath, campusColor }) => (
  <Navbar staticTop style={{ borderColor: campusColor }}>
    <Header style={{ backgroundColor: campusColor }}>
      <Brand>
        <Link to="/"><span className="icon"><Logo /></span> <sub>ISMIS</sub></Link>
      </Brand>
    </Header>
    <Nav>
      <NavDropdown title="Enrolment" id="enrolment">
        <LinkContainer to="/enrolment/apply">
          <MenuItem>Apply for Enrolment</MenuItem>
        </LinkContainer>
        <LinkContainer to="/enrolment/modify">
          <MenuItem>Modify Enrolment</MenuItem>
        </LinkContainer>
        <LinkContainer to="/enrolment/add-withdraw-subjects">
          <MenuItem>Add/Withdraw Subjects</MenuItem>
        </LinkContainer>
      </NavDropdown>
      <LinkContainer to="/cor">
        <NavItem>COR</NavItem>
      </LinkContainer>
      <NavDropdown title="Grades" id="grades">
        <LinkContainer to="/grades">
          <MenuItem>Report of Grades</MenuItem>
        </LinkContainer>
        <LinkContainer to="/curriculum">
          <MenuItem>Curriculum</MenuItem>
        </LinkContainer>
      </NavDropdown>
      <NavDropdown title="Billing" id="billing">
        <LinkContainer to="/billing">
          <MenuItem>Billing Assessment</MenuItem>
        </LinkContainer>
        <LinkContainer to="/ledger">
          <MenuItem>Ledger</MenuItem>
        </LinkContainer>
      </NavDropdown>
    </Nav>
    <Nav pullRight>
      <ChangeSemester
        session={session}
        currentPath={currentPath}
      />
      <NavDropdown title={name} id="usermenu">
        <LinkContainer to="/account">
          <MenuItem>My Account</MenuItem>
        </LinkContainer>
        <LinkContainer to="/logout">
          <MenuItem>Log out</MenuItem>
        </LinkContainer>
      </NavDropdown>
    </Nav>
  </Navbar>
)

TopNav.propTypes = {
  name: PropTypes.string,
  campusColor: PropTypes.string,
}

export default TopNav



// WEBPACK FOOTER //
// ./src/partials/TopNav/index.js